export default __webpack_public_path__ + "static/media/md-call.e026289d.svg";